// export const BASE_URL = "http://localhost:3001";
export const BASE_URL = `https://shop-it-backend.onrender.com`;
